<template>
	
	<div class="wizard-component radio-buttons with-date">

		<p class="subject">How is water settled?</p>

		<div v-for="item in radiobuttonsDate">
			<label class="custom-radio">
				<input type="radio" id="item.id" v-bind:value="item.value" v-model="picked">
				<span class="radio-circle"></span>
				<p>{{ item.labelText }}</p>
			</label>
		
			<div v-if="picked">
			<div class="choices-dropdown" v-if="item.dateInput">
				<div class="content">
					<p class="subject">{{ item.subText }}</p>
					<div class="date-input">
						<input type="date" name="">
					</div>
				</div>
			</div>
		</div>
		
		</div>
	</div>

</template>


<script>
	import {mapGetters} from 'vuex';
    import {store} from '../../../store/index'
    export default {
	

		data: () => ({
			picked: '',
			radiobuttonsDate: [
				{
					id: 'one',
					value: 'One',
					labelText: 'A conto to landlord',
					subText: 'The billing starts on',
					dateInput: true
				},
				{
					id: 'two',
					value: 'Two',
					labelText: 'Included in the rent',
					dateInput: false
				}
			]

		})

	}
</script>


<style></style>